// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 6.4998V17.4998L1 17.5L1 6.5L5 6.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 18.2099L15.0004 22.7095L15.0004 1.29004L7 5.7896V18.2099Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.5814 7.77945L20.9788 6.98145L19.3828 8.18675L19.9854 8.98475C20.6412 9.85308 20.9958 10.9116 20.9954 11.9998C20.995 13.0879 20.6397 14.1462 19.9833 15.0141L19.3801 15.8116L20.9753 17.0181L21.5785 16.2205C22.4974 15.0054 22.9949 13.5238 22.9954 12.0005C22.9959 10.4771 22.4995 8.99511 21.5814 7.77945Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.7887 9.88858L18.1861 9.09058L16.5901 10.2959L17.1927 11.0939C17.3894 11.3544 17.4958 11.6719 17.4957 11.9984C17.4956 12.3248 17.389 12.6423 17.1921 12.9027L16.5889 13.7003L18.184 14.9067L18.7872 14.1091C19.2467 13.5016 19.4954 12.7608 19.4957 11.9991C19.496 11.2374 19.2478 10.4964 18.7887 9.88858Z"}}]};

const SoundFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-filled',
    ref,
    icon: element,
  },
));

SoundFilledIcon.displayName = 'SoundFilledIcon';

export default SoundFilledIcon;
